import styled from 'styled-components';
import { Dropdown } from '../../../Dropdown';
import { ColorSwatch } from '../../../baseInputs/ColorSwatch';
import { DropdownInput } from '../../../baseInputs/DropdownInput';
import { NumberInput } from '../../../baseInputs/NumberInput';
import { ColorPickerModalContent } from '../../../baseInputs/colorInput/ColorPickerModalContent';
import { useMemo } from 'react';

export const BorderInput = ({
  data,
  updateData,
}: {
  data: {
    borderWidth?: string | number;
    borderStyle?: string;
    borderColor?: string;

    borderTopWidth?: string | number;
    borderTopStyle?: string;
    borderTopColor?: string;

    borderBottomWidth?: string | number;
    borderBottomStyle?: string;
    borderBottomColor?: string;

    borderLeftWidth?: string | number;
    borderLeftStyle?: string;
    borderLeftColor?: string;

    borderRightWidth?: string | number;
    borderRightStyle?: string;
    borderRightColor?: string;
  };
  updateData: (props: { [key: string]: any }) => void;
}) => {
  const borderAllWidthValue = useMemo(
    () =>
      data.borderTopWidth === data.borderBottomWidth &&
        data.borderBottomWidth === data.borderLeftWidth &&
        data.borderLeftWidth === data.borderRightWidth
        ? data.borderTopWidth === undefined ? data.borderWidth : data.borderTopWidth
        : null,
    [data]
  );

  const borderAllStyleValue = useMemo(
    () =>
      data.borderTopStyle === data.borderBottomStyle &&
        data.borderBottomStyle === data.borderLeftStyle &&
        data.borderLeftStyle === data.borderRightStyle
        ? data.borderTopStyle === undefined ? data.borderStyle : data.borderTopStyle
        : null,
    [data]
  );

  const borderAllColorValue = useMemo(
    () =>
      data.borderTopColor === data.borderBottomColor &&
        data.borderBottomColor === data.borderLeftColor &&
        data.borderLeftColor === data.borderRightColor
        ? data.borderTopColor === undefined ? data.borderColor : data.borderTopColor
        : null,
    [data]
  );

  return (
    <>
      <Dropdown
        trigger={
          <DropdownButton>
            <i className="icon-triple-dots" />
          </DropdownButton>
        }
        style={{
          width: '16px',
          height: '30px',
        }}
        horizontalAlign="left"
        closeOnClick={false}
      >
        <DropdownContentContainer>
          <Row>
            <Icon className="icon-border-all" />
            <DropdownLabel>All</DropdownLabel>
            <NumberInput
              value={borderAllWidthValue}
              onChange={(newValue) => newValue !== undefined && updateData({ borderWidth: undefined, borderTopWidth: newValue, borderBottomWidth: newValue, borderLeftWidth: newValue, borderRightWidth: newValue })}
              inputStyle={{ textAlign: 'center' }}
              defaultUnit="px"
              precision={0}
              minValue={0}
              draggingSensitive={0.1}
              style={{ maxWidth: '50px', minWidth: '50px' }}
            />
            <DropdownInput
              value={borderAllStyleValue}
              onChange={(newValue) => newValue !== undefined && updateData({ borderStyle: undefined, borderTopStyle: newValue, borderBottomStyle: newValue, borderLeftStyle: newValue, borderRightStyle: newValue })}
              options={[
                { value: 'solid', label: 'solid' },
                { value: 'dashed', label: 'dashed' },
                { value: 'dotted', label: 'dotted' },
              ]}
              canBeCleared={false}
              style={{ maxWidth: '80px', minWidth: '80px' }}
            />
            <Dropdown
              trigger={
                <ColorSwatchContainer>
                  <ColorSwatch value={borderAllColorValue} />
                </ColorSwatchContainer>
              }
              closeOnClick={false}
              horizontalAlign="right"
            >
              <DropdownContentContainer>
                <ColorPickerModalContent
                  value={borderAllColorValue}
                  onChange={(newValue) => newValue !== undefined && updateData({ borderColor: undefined, borderTopColor: newValue, borderBottomColor: newValue, borderLeftColor: newValue, borderRightColor: newValue })}
                />
              </DropdownContentContainer>
            </Dropdown>
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '180deg' }} />
            <DropdownLabel>Top</DropdownLabel>
            <NumberInput
              value={data.borderTopWidth}
              onChange={(newValue) => newValue !== undefined && updateData({ borderWidth: undefined, borderTopWidth: newValue })}
              inputStyle={{ textAlign: 'center' }}
              defaultUnit="px"
              precision={0}
              minValue={0}
              draggingSensitive={0.1}
              style={{ maxWidth: '50px', minWidth: '50px' }}
            />
            <DropdownInput
              value={data.borderTopStyle}
              onChange={(newValue) => newValue !== undefined && updateData({ borderStyle: undefined, borderTopStyle: newValue })}
              options={[
                { value: 'solid', label: 'solid' },
                { value: 'dashed', label: 'dashed' },
                { value: 'dotted', label: 'dotted' },
              ]}
              canBeCleared={false}
              style={{ maxWidth: '80px', minWidth: '80px' }}
            />
            <Dropdown
              trigger={
                <ColorSwatchContainer>
                  <ColorSwatch value={data.borderTopColor} />
                </ColorSwatchContainer>
              }
              closeOnClick={false}
              horizontalAlign="right"
            >
              <DropdownContentContainer>
                <ColorPickerModalContent
                  value={data.borderTopColor}
                  onChange={(newValue) => newValue !== undefined && updateData({ borderColor: undefined, borderTopColor: newValue })}
                />
              </DropdownContentContainer>
            </Dropdown>
          </Row>
          <Row>
            <Icon className="icon-border" />
            <DropdownLabel>Bottom</DropdownLabel>
            <NumberInput
              value={data.borderBottomWidth}
              onChange={(newValue) => newValue !== undefined && updateData({ borderWidth: undefined, borderBottomWidth: newValue })}
              inputStyle={{ textAlign: 'center' }}
              defaultUnit="px"
              precision={0}
              minValue={0}
              draggingSensitive={0.1}
              style={{ maxWidth: '50px', minWidth: '50px' }}

            />
            <DropdownInput
              value={data.borderBottomStyle}
              onChange={(newValue) => newValue !== undefined && updateData({ borderStyle: undefined, borderBottomStyle: newValue })}
              options={[
                { value: 'solid', label: 'solid' },
                { value: 'dashed', label: 'dashed' },
                { value: 'dotted', label: 'dotted' },
              ]}
              canBeCleared={false}
              style={{ maxWidth: '80px', minWidth: '80px' }}
            />
            <Dropdown
              trigger={
                <ColorSwatchContainer>
                  <ColorSwatch value={data.borderBottomColor} />
                </ColorSwatchContainer>
              }
              closeOnClick={false}
              horizontalAlign="right"
            >
              <DropdownContentContainer>
                <ColorPickerModalContent
                  value={data.borderBottomColor}
                  onChange={(newValue) => newValue !== undefined && updateData({ borderColor: undefined, borderBottomColor: newValue })}
                />
              </DropdownContentContainer>
            </Dropdown>
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '90deg' }} />
            <DropdownLabel>Left</DropdownLabel>
            <NumberInput
              value={data.borderLeftWidth}
              onChange={(newValue) => newValue !== undefined && updateData({ borderWidth: undefined, borderLeftWidth: newValue })}
              inputStyle={{ textAlign: 'center' }}
              defaultUnit="px"
              precision={0}
              minValue={0}
              draggingSensitive={0.1}
              style={{ maxWidth: '50px', minWidth: '50px' }}
            />
            <DropdownInput
              value={data.borderLeftStyle}
              onChange={(newValue) => newValue !== undefined && updateData({ borderStyle: undefined, borderLeftStyle: newValue })}
              options={[
                { value: 'solid', label: 'solid' },
                { value: 'dashed', label: 'dashed' },
                { value: 'dotted', label: 'dotted' },
              ]}
              canBeCleared={false}
              style={{ maxWidth: '80px', minWidth: '80px' }}
            />
            <Dropdown
              trigger={
                <ColorSwatchContainer>
                  <ColorSwatch value={data.borderLeftColor} />
                </ColorSwatchContainer>
              }
              closeOnClick={false}
              horizontalAlign="right"
            >
              <DropdownContentContainer>
                <ColorPickerModalContent
                  value={data.borderLeftColor}
                  onChange={(newValue) => newValue !== undefined && updateData({ borderColor: undefined, borderLeftColor: newValue })}
                />
              </DropdownContentContainer>
            </Dropdown>
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '-90deg' }} />
            <DropdownLabel>Right</DropdownLabel>
            <NumberInput
              value={data.borderRightWidth}
              onChange={(newValue) => newValue !== undefined && updateData({ borderWidth: undefined, borderRightWidth: newValue })}
              inputStyle={{ textAlign: 'center' }}
              defaultUnit="px"
              precision={0}
              minValue={0}
              draggingSensitive={0.1}
              style={{ maxWidth: '50px', minWidth: '50px' }}
            />
            <DropdownInput
              value={data.borderRightStyle}
              onChange={(newValue) => newValue !== undefined && updateData({ borderStyle: undefined, borderRightStyle: newValue })}
              options={[
                { value: 'solid', label: 'solid' },
                { value: 'dashed', label: 'dashed' },
                { value: 'dotted', label: 'dotted' },
              ]}
              canBeCleared={false}
              style={{ maxWidth: '80px', minWidth: '80px' }}
            />
            <Dropdown
              trigger={
                <ColorSwatchContainer>
                  <ColorSwatch value={data.borderRightColor} />
                </ColorSwatchContainer>
              }
              closeOnClick={false}
              horizontalAlign="right"
            >
              <DropdownContentContainer>
                <ColorPickerModalContent
                  value={data.borderRightColor}
                  onChange={(newValue) => newValue !== undefined && updateData({ borderColor: undefined, borderRightColor: newValue })}
                />
              </DropdownContentContainer>
            </Dropdown>
          </Row>
        </DropdownContentContainer>
      </Dropdown>

      <Label>Border</Label>
      <NumberInput
        value={borderAllWidthValue}
        onChange={(newValue) => newValue !== undefined && updateData({ borderWidth: undefined, borderTopWidth: newValue, borderBottomWidth: newValue, borderLeftWidth: newValue, borderRightWidth: newValue })}
        inputStyle={{ textAlign: 'center' }}
        defaultUnit="px"
        precision={0}
        minValue={0}
        draggingSensitive={0.1}
        style={{ maxWidth: '50px' }}
      />
      <DropdownInput
        value={borderAllStyleValue}
        onChange={(newValue) => newValue !== undefined && updateData({ borderStyle: undefined, borderTopStyle: newValue, borderBottomStyle: newValue, borderLeftStyle: newValue, borderRightStyle: newValue })}
        options={[
          { value: 'solid', label: 'solid' },
          { value: 'dashed', label: 'dashed' },
          { value: 'dotted', label: 'dotted' },
        ]}
        canBeCleared={false}
        style={{ maxWidth: '80px' }}
      />
      <Dropdown
        trigger={
          <ColorSwatchContainer>
            <ColorSwatch value={borderAllColorValue} />
          </ColorSwatchContainer>
        }
        closeOnClick={false}
        horizontalAlign="right"
      >
        <DropdownContentContainer>
          <ColorPickerModalContent
            value={borderAllColorValue}
            onChange={(newValue) => newValue !== undefined && updateData({ borderColor: undefined, borderTopColor: newValue, borderBottomColor: newValue, borderLeftColor: newValue, borderRightColor: newValue })}
          />
        </DropdownContentContainer>
      </Dropdown>
    </>
  );
};

const Label = styled.label`
  padding-right: 5px;
  padding-left: 8px;

  color: var(--main-2);
  font-family: var(--font-2);
  font-size: 13px;
  white-space: nowrap;

  display: flex;
  align-items: center;

  i {
    width: 20px;
    font-size: 19px;
    translate: -2px 0;
  }
`;

const DropdownLabel = styled.div`
  width: 40px;
  heigth: 22px;

  font-size: 11px;
  display: flex;
  align-items: center;
`;

const ColorSwatchContainer = styled.div``;

const DropdownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-left: 6px;
  padding: 5px;
  gap: 7px;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  box-shadow: var(--shadow-1);
`;

const Row = styled.div`
  position: relative;
  width: 100%;
  display: flex;

  gap: 5px;
`;

const DropdownRow = styled.div`
  position: relative;
  width: 100%;
  display: flex;

  gap: 5px;
`;

const DropdownButton = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 5px;

  & > i {
    rotate: 90deg;
    font-size: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  transition:
    background-color 0.2s,
    color 0.2s;
  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }
`;

const Icon = styled.i`
  font-size: 15px;
  width: 22px;
  height: 22px;

  display: flex;
  justify-content: center;
  align-items: center;
`;